import _                from 'lodash'
import React            from 'react'
import { DropdownList } from 'react-widgets'

normalize = (str) -> _.toLower(_.deburr(str))

class CustomDropdownList extends DropdownList.ControlledComponent
  componentDidUpdate: (prevProps) ->
    if @props.searchTerm != prevProps.searchTerm
      @setState(focusedItem: @state.list.first())

export default class ClientSelect extends React.Component
  constructor: (props) ->
    super(props)

    @state     = { open: false, search: '' }
    @selectRef = React.createRef()

  render: ->
    <CustomDropdownList
     ref={@selectRef}
     open={@state.open}
     data={@props.clients or []}
     busy={not @props.clients}
     filter={@filter.bind(@)}
     value={@props.selected}
     messages={@messages}
     textField={@clientToText}
     searchTerm={@props.searchTerm}
     onToggle={(open) => @setState({ open }); @props.onToggle?(open)}
     onChange={@props.onChange}
     onSearch={@props.onSearch} />

  messages:
    emptyList: 'Neexistují žádní uživatelé'
    emptyFilter: 'Takový uživatel neexistuje'
    filterPlaceholder: 'Vyhledejte podle jména nebo osobního čísla'

  filter: (client, searchTerm) ->
    _.includes(normalize(@clientToText(client)), normalize(searchTerm))

  clientToText: (client) ->
    client and "#{client.firstname} #{client.surname} (#{client.clientId})"

  submitSearch: ->
    select    = @selectRef.current
    selection = select.state.focusedItem

    if _.isEmpty(selection)
      false
    else
      select.handleSelect(selection)
      true
